

export const URL_HELPERS= {

    BUILD_URL:( protocol,host, port = null) => {
        const PORT =  port !== null  ? `:${port}` : "";
        return `${protocol}://${host}${PORT}`;
    },





    

};